export default {
  statusWrapper: {
    paddingLeft: 14
  },
  addBranchText: {
    paddingLeft: 20,
    color: '#4B2885',
    cursor: 'pointer',
    fontFamily: 'Kanit-Regular'
  },
  addBranchTextInner: {
    textDecoration: 'underline'
  }
};
